
skrilla.service('paymentIqService', function(envService){
    function piqHost() {
        return envService.get() === 'production' ? "backoffice.paymentiq.io" : 'test-bo.paymentiq.io';
    }
    const getTransactionUrl =  function(txId){
        return  `https://${(piqHost())}/#es-transaction/search/${txId}`
    }
    const getApprovalUrl =  function(txId){
        return  `https://${(piqHost())}/#es-approve/search/${txId}`
    }

    return {
        getTransactionUrl,
        getApprovalUrl,
    };
});

